var _path, _polygon, _rect, _polygon2, _polygon3, _rect2, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSiteAppt = function SvgSiteAppt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31.75,
    height: 30,
    viewBox: "0 0 31.75 30",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,16A7.5,7.5,0,1,0,31,23.5,7.5,7.5,0,0,0,23.5,16Zm0,13A5.5,5.5,0,1,1,29,23.5,5.50685,5.50685,0,0,1,23.5,29Z",
    transform: "translate(-0.125 -1)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "27.151 24.947 22.875 22.809 22.875 18 23.875 18 23.875 22.191 27.599 24.053 27.151 24.947"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.375,
    y: 10,
    width: 7,
    height: 5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "26.875 9.73 22.875 8.73 22.875 1 26.875 1 26.875 9.73"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "31.75 12.855 15.875 0 0 12.855 2.25 15.105 15.875 4 29.5 15.105 31.75 12.855"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.875,
    y: 9.51769,
    width: 2,
    height: 17.48231
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.37506,26H5v2H16.29828A8.44541,8.44541,0,0,1,15.37506,26Z",
    transform: "translate(-0.125 -1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27,15.76019V10.5177H25v4.62244A8.42777,8.42777,0,0,1,27,15.76019Z",
    transform: "translate(-0.125 -1)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSiteAppt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/siteAppt.272f1ad4.svg";
export { ForwardRef as ReactComponent };